import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  IconButton, Modal, ModalBody, ModalHeader,
} from '@americanexpress/dls-react';
import { IconInfo } from '@americanexpress/dls-icons';

const DriversAgeInfoModal = () => {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => { setIsOpen(true); };
  const closeModal = () => { setIsOpen(false); };
  const { locale } = useIntl();

  return (
    <>
      <IconButton
        screenReaderLabel={formatMessage({ id: 'driversAge.tooltip.ariaLabel' })}
        shape="round"
        variant="tertiary"
        id="drivers-age_modal_btn"
        onClick={openModal}
        reactlytics={{ element: 'cars_drivers-age_modal' }}
      >
        <IconInfo style={{ width: '1rem' }} />
      </IconButton>
      {
        isOpen && (
          <Modal
            id="driversAgeModal"
            aria-labelledby="drivers-age_modal_btn"
            onClose={closeModal}
          >
            <ModalHeader>
              <h2>{formatMessage({ id: 'driversAge.modal.title' })}</h2>
            </ModalHeader>
            <ModalBody style={{ maxWidth: locale.toString().includes('en') ? '30rem' : '40rem' }}>
              {formatMessage({ id: 'driversAge.modal.text' })}
            </ModalBody>
          </Modal>
        )
      }
    </>
  );
};

export default DriversAgeInfoModal;
